export default "__VITE_ASSET__DWOUWWsN__"